import {take, fork, all, call, put} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import {surveySuccess, surveyFailure} from '../actions/action_survey';

function* watchOne() {
    while (true) {
        const {payload} = yield take(constants.SURVEY_REQUESTED);
        try {
            const response = yield call(api.fetchSurvey, payload.id);
            yield put(surveySuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(surveyFailure(error));
        }
    }
}

function* watchEdit() {
    while (true) {
        const {payload} = yield take(constants.SURVEY_EDIT_REQUESTED);
        try {
            const response = yield call(api.editSurvey, payload.id, payload.data);
            yield put(surveySuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(surveyFailure(error));
        }
    }
}

function* watchCreate() {
    while (true) {
        const {payload} = yield take(constants.SURVEY_CREATE_REQUESTED);
        try {
            const response = yield call(api.createSurvey, payload.data);
            yield put(surveySuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(surveyFailure(error));
        }
    }
}

export default function* root() {
    yield all([
        fork(watchOne),
        fork(watchEdit),
        fork(watchCreate),
    ]);
}
